<template>
    <div class="section-card">
        <p class="heading mb-3">{{ translatedLang[`${heading} Performance`][selectedLanguage.key] }}</p>
        <div class="performance-tabs" v-if="showTabs">
            <ul>
                <li v-for="tab of tabs" :key="tab" :class="{ 'selected-tab': tab === selectedTab }"
                    @click="selectedTab = tab">{{ translatedLang[tab][selectedLanguage.key] }}</li>
            </ul>
            <div v-show="selectedTab === 'Ratings'">
                <b-button-toolbar aria-label="Toolbar with buttons group">
                    <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
                        v-model="ratingInterval" name="radiosBtn">
                        <b-form-radio class="mx-0" value="month_on_month">
                            {{ translatedLang['Month'][selectedLanguage.key] }}
                        </b-form-radio>
                        <b-form-radio class="mx-0" value="week_on_week">
                            {{ translatedLang['Week'][selectedLanguage.key] }}
                        </b-form-radio>
                    </b-form-radio-group>
                </b-button-toolbar>
            </div>
        </div>
        <AreaLineChart :rawData="performanceData" v-if="selectedTab === 'Reviews'" />
        <MultiLineChart :rawData="rawPerformanceRatingData" v-else />
    </div>
</template>
<script>
import moment from 'moment';
import AreaLineChart from '../../commonCharts/AreaLineChart.vue';
import MultiLineChart from '../../commonCharts/MultiLineChart.vue';
import { mapState, mapActions } from "vuex";

export default {
    name: 'PerformanceChart',
    components: {
        AreaLineChart,
        MultiLineChart
    },
    props: {
        heading: String,
        performanceData: {
            type: Array,
            required: true
        },
        performanceRatingsData: {
            type: Object,
            required: false,
            default: () => []
        },
        showTabs: {
            type: Boolean,
            required: false,
            default: () => false
        }
    },
    data() {
        return {
            tabs: ["Reviews", "Ratings"],
            selectedTab: "Reviews",
            ratingInterval: "month_on_month",
            rawPerformanceRatingData: {
                categories: [],
                seriesData: []
            }
        }
    },
    mounted() {
        this.prepareRatingsChartData();
    },
    computed: {
        ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    },
    watch: {
        performanceRatingsData: {
            handler() {
                this.prepareRatingsChartData()
            },
            deep: true
        },
        ratingInterval: {
            handler() {
                this.prepareRatingsChartData()
            },
            deep: true
        }
    },
    methods: {
        ...mapActions("DemoStore", [
            "setSelectedLanguage",
            "initializeTranslation",
        ]),
        prepareRatingsChartData() {
            let categories = [];
            let seriesData = [
                {
                    name: `1 ${this.translatedLang['star'][this.selectedLanguage.key]}`,
                    data: [],
                    color: "#F2453D"
                },
                {
                    name: `2 ${this.translatedLang['star'][this.selectedLanguage.key]}`,
                    data: [],
                    color: "#FD9827"
                },
                {
                    name: `3 ${this.translatedLang['star'][this.selectedLanguage.key]}`,
                    data: [],
                    color: "#1FBCD3"
                },
                {
                    name: `4 ${this.translatedLang['star'][this.selectedLanguage.key]}`,
                    data: [],
                    color: "#2C98F0"
                },
                {
                    name: `5 ${this.translatedLang['star'][this.selectedLanguage.key]}`,
                    data: [],
                    color: "#1BA96F"
                },
            ];

            this.performanceRatingsData[this.ratingInterval].forEach(dataPoint => {
                if (this.ratingInterval === 'month_on_month') {
                    categories.push(moment(dataPoint.date).format('MMM'));
                } else {
                    categories.push(moment(dataPoint.date).format('DD MMM YY'));
                }

                dataPoint.data.forEach((ratingData, index) => {
                    seriesData[index].data.push(ratingData.count)
                })
            });

            this.rawPerformanceRatingData.categories = categories;
            this.rawPerformanceRatingData.seriesData = seriesData;
        }
    }
}
</script>
<style>
.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.performance-tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #D4D4D4;

    &>ul {
        list-style: none;
        display: flex;
        align-items: center;
        gap: 20px;
        margin: 0 !important;
        padding: 0;

        &>li {
            padding-bottom: 16px;
            margin: 0;
            font-size: 16px;
            cursor: pointer;
        }

        &>li.selected-tab {
            border-bottom: 1px solid #065559;
            margin-bottom: -1px;
            color: #065559;
            font-weight: 500;
        }
    }
}
</style>